import React from 'react';
import { formatCurrencyUnit, formatStat, getUsdValue } from '../../utils/formatters';

export function GaMonthlySummary({ gaMonthlySummary, allCostsByMonth, totalAllCosts }) {
  if (!gaMonthlySummary?.monthlyData?.length) {
    return <p className="text-xs text-gray-400 text-center py-4">No GA summary data available</p>;
  }

  const { monthlyData, totals } = gaMonthlySummary;

  return (
    <div className="overflow-x-auto">
      <table className="modern-table w-full">
        <thead>
          <tr>
            <th className="text-left">Month</th>
            <th className="text-right">Sessions</th>
            <th className="text-right">Users</th>
            <th className="text-right">Purchases</th>
            <th className="text-right">Revenue (TRY)</th>
            <th className="text-right">Revenue (USD)</th>
            <th className="text-right">Ad Cost</th>
            <th className="text-right">CR%</th>
          </tr>
        </thead>
        <tbody>
          {monthlyData.map((m, i) => {
            const adCost = allCostsByMonth?.[m.month] || 0;
            const usdRevenue = getUsdValue(m.totalRevenue, m.displayMonthKey);
            return (
              <tr key={i}>
                <td className="text-xs font-medium text-gray-700 whitespace-nowrap">{m.month}</td>
                <td className="text-right text-xs">{formatStat(m.sessions)}</td>
                <td className="text-right text-xs">{formatStat(m.users)}</td>
                <td className="text-right text-xs">{formatStat(m.eventCount)}</td>
                <td className="text-right text-xs font-medium">{formatCurrencyUnit(m.totalRevenue)}</td>
                <td className="text-right text-xs text-gray-500">{formatStat(Math.round(usdRevenue))}</td>
                <td className="text-right text-xs">{formatCurrencyUnit(adCost)}</td>
                <td className="text-right text-xs">
                  <span className={m.conversionRate >= 2 ? 'text-emerald-600 font-semibold' : 'text-gray-600'}>
                    {m.conversionRate.toFixed(2)}%
                  </span>
                </td>
              </tr>
            );
          })}
          <tr className="font-bold bg-gray-50/50">
            <td className="text-xs font-bold">Total</td>
            <td className="text-right text-xs font-bold">{formatStat(totals.sessions)}</td>
            <td className="text-right text-xs font-bold">{formatStat(totals.users)}</td>
            <td className="text-right text-xs font-bold">{formatStat(totals.eventCount)}</td>
            <td className="text-right text-xs font-bold">{formatCurrencyUnit(totals.totalRevenue)}</td>
            <td className="text-right text-xs font-bold text-gray-500">-</td>
            <td className="text-right text-xs font-bold">{formatCurrencyUnit(totalAllCosts)}</td>
            <td className="text-right text-xs font-bold">{(totals.conversionRate || 0).toFixed(2)}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
